const statusModule = {
  payStatus0: "Unpaid",
  payStatus1: "Payment completed",
  payStatus3: "successfully refunded",
  payStatus4: "Failed to refund",
  "orderStatus-1": "Canceled",
  orderStatus0: "Pending",
  orderStatus1: "Confirmed",
  orderStatus2: "Completed",
  orderAll: "All",
  payFun3: "Pay in cash",
  payFun3_1: "Pay in cash",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  Sunday: "Sunday",
  zhuri: 'Zhu ri',
  sex0: "Keep secret",
  sex1: "Male",
  sex2: "Female",
  loading: "Loading",
  noMore: "No more",
  feedbackType0: "About order",
  feedbackType1: "About member information",
  feedbackType2: "About application method",
  feedbackType3: "Other",
  payType1: "WechatPay",
  payType2: "Alipay",
  payType3: "Credit card"
};
export default statusModule;
